import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";
import Trash from "../../../assets/img/Garbage.svg";

function DeleteSerieConfirmation({ type, onConfirm, onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };
  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>
              {type === "all"
                ? "Supprimer toute une série d'écritures"
                : "Supprimer une seule écriture"}
            </p>
          </div>
          <h1 className="popup-desc-content">
            {type === "all"
              ? "Toute la série sélectionnée sera supprimée. Êtes vous sûr de continuer ?"
              : "L'écriture que vous allez supprimer fait partie d'une série. Seule cette écriture sera supprimée. Êtes vous sûr de continuer ?"}
          </h1>
          <div className="delete-button-containers">
            <Button
              text={"Non"}
              onClick={handleCloseDialog}
              className={"action-button"}
            />
            <Button
              text={"Oui"}
              onClick={handleConfirm}
              className={"action-button agree-action-button"}
              icon={"empty"}
              RigthIcon={Trash}
              isRigthIcon
              iconClassName={"delete-icon"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default DeleteSerieConfirmation;
